module.exports = "\n  <component :is=\"tag\" class=\"scrollactive-nav\" ref=\"scrollactive-nav-wrapper\">\n    <slot></slot>\n  </component>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/scroll-active.vue
// module id = 262
// module chunks = 0